import { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import { AgentsContext } from 'contexts';

import errorReporter from '@app/errorReporter';
import { message } from 'components';

const useGetGroup = (groupId: string) => {
  const { orgUsersMap } = useContext(AgentsContext);
  const [isLoading, setIsLoading] = useState(false);
  const [groupMembers, setGroupMembers] = useState<string[]>([]);
  const [groupName, setGroupName] = useState('');
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        if (isFirstLoad.current) setIsLoading(true);
        const {
          data: { users, name },
        } = await axios.get<{ users: { id: string }[]; name: string }>(
          `group/${groupId}`,
        );
        const filteredUsers = users.reduce((acc, cur) => {
          if (orgUsersMap![cur.id]) acc.push(cur.id);
          return acc;
        }, [] as string[]);

        setGroupMembers(filteredUsers);
        setGroupName(name);
      } catch (err) {
        errorReporter.error(err);
        message.error('Error loading group users');
      } finally {
        if (isFirstLoad.current) isFirstLoad.current = false;
        setIsLoading(false);
      }
    };
    if (groupId && orgUsersMap && Object.keys(orgUsersMap).length) fetchGroup();
  }, [orgUsersMap]);

  return { groupMembers, groupName, setGroupName, setGroupMembers, isLoading };
};

export default useGetGroup;
